// remove tudo que não é número
export const onlyNumbers = (value = "") =>
  value.replace(/\D/g, "");

// detecta bandeira
export function getCardBrand(number = "") {
  const n = number.replace(/\D/g, "");

  if (/^3[47]/.test(n)) return "amex";
  if (/^4/.test(n)) return "visa";
  if (/^(5[1-5]|2[2-7])/.test(n)) return "mastercard";
  if (/^(401178|401179|431274|438935|451416|457393|457631|457632|504175|5067|509|650)/.test(n)) return "elo";
  if (/^(606282|3841)/.test(n)) return "hipercard";

  return "unknown";
}

// tamanho esperado
export function getCardLength(brand) {
  if (brand === "amex") return 15;
  return 16;
}

// Luhn
export function isValidCardNumber(number = "") {
  const digits = number.replace(/\D/g, "");
  let sum = 0;
  let shouldDouble = false;

  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits[i]);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

// mês
export function isValidMonth(month) {
  const m = Number(month);
  return m >= 1 && m <= 12;
}

// ano
export function isValidYear(year) {
  const y = Number(year);
  const current = new Date().getFullYear() % 100;
  return y >= current;
}

// cvv
export function isValidCVV(cvv) {
  return /^\d{3}$/.test(cvv);
}
